import { useContext } from "react";
import { IContextValueProvider } from "sonobello.utilities.react";

import EventContext, { EventContextProps } from "../EventContext";

/** A Value Provider composed from the {@link EventContextProps}. */
function EventContextValueProvider<TFulfilledProps, TComponent extends TFulfilledProps>({
  Component,
  map
}: IContextValueProvider<EventContextProps, TFulfilledProps, TComponent>): React.FC<
  Omit<TComponent, keyof TFulfilledProps>
> {
  return componentProps => {
    const contextProps = useContext(EventContext);
    return Component({ ...componentProps, ...map(contextProps) } as unknown as TComponent);
  };
}

export default EventContextValueProvider;
